import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Grid, Row } from 'react-bootstrap';
// src
import * as routes from '../routes/routes_production.js';
import NavigationBar from './NavigationBar/NavigationBar.js';
import NewOrder from './Orders/NewOrder.js';
import EditOrder from './Orders/EditOrder.js';
import Summary from './Summary/Summary.js';
import './styles/commonStyles.css';

const Home = () => (
  <Grid>
    <NavigationBar />
    <Row className="show-grid">
      <Route path={routes.NEW_ORDER} component={NewOrder} />
      <Route path={routes.EDIT_ORDER} component={EditOrder} />
      <Route path={routes.ORDERS_SUMMARY} component={Summary} />      

      <Route exact path={routes.HOME} render={() => <Redirect to={routes.NEW_ORDER} />} />
    </Row>
  </Grid>
);


export default Home;


// WEBPACK FOOTER //
// ./src/cmp/Home.js